<template>
  <div class="app-wrapper">
    <Navbar />
    <router-view />
    <Footer />
    <Dialog
      title="小着会员申请"
      :visible="$store.state.applyShow"
      @close="closeApplyDialog">
      <div class="apply-dialog-form">
        <div class="form-title">
          <p>
            小着是会员专属的
          </p>
        </div>
        <div class="form-content-wrapper">
          <div class="form-item">
            <div class="form-label form-label-required">
              姓名
            </div>
            <div class="form-content">
              <input
                type="text"
                v-model="formData.user_name"
                placeholder="真实姓名"
                class="form-input"
                @blur="doValid">
              <div
                v-show="nameInvalid"
                class="error-tip">
                最多输入10个字
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label form-label-required">
              职业
            </div>
            <div class="form-content">
              <input
                type="text"
                v-model="formData.user_job"
                placeholder="例如：设计师"
                class="form-input"
                @blur="doValid">
              <div
                v-show="jobInvalid"
                class="error-tip">
                最多输入16个字
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label form-label-required">
              手机号
            </div>
            <div class="form-content">
              <input
                type="text"
                v-model="formData.user_mobile"
                placeholder="本人手机号"
                class="form-input"
                @blur="doValid">
              <div
                v-show="phoneInvalid"
                class="error-tip">
                手机格式不正确
              </div>
            </div>
          </div>
          <div class="form-item address-item">
            <div class="form-label form-label-required">
              是否在望京
            </div>
            <div class="form-content">
              <div class="radio-group">
                <div class="radio-item">
                  <img
                    :src="formData.user_live === '1' ? radioChecked : radioDefault"
                    class="radio-img"
                    @click="changeRadio('1')">
                  <p
                    class="radio-text"
                    @click="changeRadio('1')">
                    经常
                  </p>
                </div>
                <div class="radio-item">
                  <img
                    :src="formData.user_live === '2' ? radioChecked : radioDefault"
                    class="radio-img"
                    @click="changeRadio('2')">
                  <p
                    class="radio-text"
                    @click="changeRadio('2')">
                    偶尔
                  </p>
                </div>
                <div class="radio-item">
                  <img
                    :src="formData.user_live === '3' ? radioChecked : radioDefault"
                    class="radio-img"
                    @click="changeRadio('3')">
                  <p
                    class="radio-text"
                    @click="changeRadio('3')">
                    极少
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-item">
            <div class="form-label form-label-required">
              照片
            </div>
            <div class="form-content">
              <div
                class="upload-wrapper"
                :style="{ backgroundImage: img ? `url(${uploadImg})` : `url(${uploadBg})` }">
                <input
                  ref="uploadImg"
                  class="upload-input"
                  title=""
                  accept="image/*"
                  type="file"
                  @change="changeImg">
              </div>
              <div class="upload-tip">
                <p>
                  附上你的照片（清晰，美好的自己）
                </p>
                <p>
                  支持 GIF、JPG、JPEG、PNG 格式文件
                </p>
              </div>
            </div>
          </div>
        </div>
        <input
          type="button"
          :class="['submit-btn', empty ? 'disabled-btn' : 'default-btn']"
          value="提交申请"
          @click="submitApply">
        <div class="protocol-wrapper">
          <a
            target="blank"
            href="https://pages.w.lehe.com/gls/972b5897d"
            class="protocol">
            《小着会员服务协议》
          </a>
          <p class="tip">
            此网站的“灵感”栏目里面的阅读设计、艺术、创意等精品图书，
            <br>
            都属于付费浏览信息，会员需要注册付费之后才能体验。
          </p>
        </div>
      </div>
    </Dialog>
    <Dialog
      title="小着会员申请"
      :visible.sync="applyResultShow">
      <div class="apply-result">
        <div
          v-if="applyResult === 'review'"
          class="review-wrapper">
          <div class="review-text">
            <p>
              你的会员申请还在审核中，
            </p>
            <p>
              审核结果我们将以短信方式通知。
            </p>
          </div>
          <input
            type="button"
            class="result-btn"
            value="知道了"
            @click="applyResultShow = false" />
        </div>
        <div
          v-if="applyResult === 'success'"
          class="normal-wrapper">
          <div class="normal-content">
            <img
              src="../../assets/success.png"
              class="normal-img">
            <p>
              提交成功
            </p>
            <div class="tip">
              <p>
                非常感谢你的申请
              </p>
              <p>
                我们会尽快电话、短信回复你
              </p>
            </div>
          </div>
          <input
            type="button"
            class="result-btn"
            value="知道了"
            @click="applyResultShow = false" />
        </div>
        <div
          v-if="applyResult === 'fail'"
          class="normal-wrapper">
          <div class="normal-content">
            <img
              src="../../assets/fail.png"
              class="normal-img">
            <p>
              提交失败
            </p>
          </div>
          <input
            type="button"
            class="result-btn"
            value="重新申请"
            @click="handleReapply" />
        </div>
        <div
          v-if="applyResult === 'applied'"
          class="applied-wrapper">
          <div class="applied-conetnt">
            <div class="applied-text">
              <p>
                你已通过申请，
              </p>
              <p>
                请扫码下载小着 APP 完成入驻。
              </p>
            </div>
            <div class="applied-img-container">
              <img
                src="https://pic.lehe.com/pic/_o/30/ac/c3e9bb695a479aaecf039ff05bf6_260_260.cz.png"
                class="applied-img">
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Dialog from '@/components/Dialog.vue'
import radioChecked from '@/assets/radio-checked.png'
import radioDefault from '@/assets/radio-default.png'
import { validPhone } from '@/utils/validate.js'
import axios from 'axios'
import uploadBg from '@/assets/upload.png'
import { xzVipApply } from '@/api/applyVip.js'
export default {
  components: {
    // Navbar,
    // Footer,
    Dialog
  },
  data () {
    return {
      radioDefault,
      radioChecked,
      uploadBg,
      img: '',
      uploadImg: '',
      empty: true,
      invalid: true,
      formData: {
        user_name: '',
        user_job: '',
        user_mobile: '',
        user_image: '',
        user_live: '1',
        apply_via: 2
      },
      nameInvalid: false,
      jobInvalid: false,
      phoneInvalid: false,
      applyResultShow: false,
      applyResult: '',
      // 正在提交冷却
      submitWait: false
    }
  },
  watch: {
    'formData.user_name' (newVal, oldVal) {
      if (newVal.length > 10) {
        this.formData.user_name = oldVal
      }
    },
    'formData.user_job' (newVal, oldVal) {
      if (newVal.length > 16) {
        this.formData.user_job = oldVal
      }
    },
    'formData.user_mobile' (newVal, oldVal) {
      if (newVal.length > 11) {
        this.formData.user_mobile = oldVal
      }
    }
  },
  methods: {
    closeApplyDialog () {
      this.formData = {
        user_name: '',
        user_job: '',
        user_mobile: '',
        user_image: '',
        user_live: '1',
        apply_via: 2
      }
      this.$refs.uploadImg.value = ''
      this.img = ''
      this.uploadImg = ''
      this.empty = true
      this.invalid = true
      this.nameInvalid = false
      this.jobInvalid = false
      this.phoneInvalid = false
      this.$store.commit('SET_APPLY_SHOW', false)
    },
    changeRadio (val) {
      this.formData.user_live = val
    },
    changeImg () {
      if (this.$refs.uploadImg.files[0]) {
        const formData = new window.FormData()
        formData.append('attachment', this.$refs.uploadImg.files[0])
        this.img = this.$refs.uploadImg.files[0]
        axios
          .post('https://v.lehe.com/image/upload', formData)
          .then(res => {
            const data = res.data
            if (res.code === 0) {
              this.uploadImg = data.image_original
              this.formData.user_image = data.image_id
              this.doValid()
            }
          })
          .catch(err => {
            this.$toast(err.message)
            console.log(err)
          })
      }
    },
    doValid () {
      let empty = false
      let invalid = false
      Object.keys(this.formData).forEach(item => {
        if (this.formData[item] === '') {
          empty = true
        }
      })
      this.empty = empty
      if (this.formData.user_name && this.formData.user_name.length > 10) {
        this.nameInvalid = true
        invalid = true
      } else {
        this.nameInvalid = false
      }
      if (this.formData.user_job && this.formData.user_job.length > 16) {
        this.jobInvalid = true
        invalid = true
      } else {
        this.jobInvalid = false
      }
      if (this.formData.user_mobile && !validPhone(this.formData.user_mobile)) {
        this.phoneInvalid = true
        invalid = true
      } else {
        this.phoneInvalid = false
      }
      this.invalid = invalid
    },
    showApplyResult (type) {
      this.applyResult = type
      this.applyResultShow = true
    },
    async submitApply () {
      if (!this.submitWait) {
        this.submitWait = true
        setTimeout(() => {
          this.submitWait = false
        }, 1000)
        if (!this.empty && !this.invalid) {
          try {
            const res = await xzVipApply(JSON.parse(JSON.stringify(this.formData)))
            if (res.error_code === 0) {
              this.showApplyResult('success')
            }
          } catch (e) {
            if (e.error_code === 4162165) {
              this.showApplyResult('review')
            } else if (e.error_code === 4162164) {
              this.$toast(e.message)
              return false
            } else if (e.error_code === 4162166) {
              this.showApplyResult('applied')
            } else {
              this.showApplyResult('fail')
            }
          }
          this.closeApplyDialog()
        }
      }
    },
    handleReapply () {
      this.$store.commit('SET_APPLY_SHOW', true)
      this.applyResultShow = false
    }
  }
}
</script>

<style lang="scss">
@import '@/style/var/color.scss';
  .app-wrapper {
    .apply-dialog-form {
      width: 560px;
      text-align: center;
      font-size: 0;
      .form-title {
        line-height: 18px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        color: #000;
        p {
          margin-top: 10px;
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
      .form-content-wrapper {
        display: inline-block;
        margin-top: 24px;
        .form-item {
          margin-bottom: 16px;
          padding-right: 51px;
          &:after {
            content: "";
            display: block;
            height: 0;
            clear:both;
            visibility: hidden;
          }
          &:last-of-type {
            margin-bottom: 0;
          }
          .form-label {
            float: left;
            width: 108px;
            box-sizing: border-box;
            padding-right: 14px;
            line-height: 38px;
            text-align: right;
            font-size: 16px;
            color: #000;
            font-weight: 500;
          }
          .form-label-required::before {
            content: '* ';
            color: #FF5555;
          }
          .form-content {
            position: relative;
            float: left;
            .form-input {
              width: 280px;
              height: 38px;
              box-sizing: border-box;
              padding: 0 14px;
              line-height: 42px;
              font-size: 16px;
              color: #000;
              border: 1px solid #E9E9E9;
              border-radius: 4px;
              &::-webkit-input-placeholder { /* WebKit browsers */
                color: #999;
                font-size: 16px;
              }

              &::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: #999;
                font-size: 16px;
              }

              &:-ms-input-placeholder { /* Internet Explorer 10+ */
                color: #999;
                font-size: 16px;
              }
            }
            .radio-group {
              overflow: hidden;
              font-size: 0;
              .radio-item {
                float: left;
                margin-right: 30px;
                font-size: 0;
                color: #000;
                &:last-of-type {
                  margin-right: 0;
                }
                .radio-img {
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                  vertical-align: middle;
                  cursor: pointer;
                }
                .radio-text {
                  display: inline-block;
                  vertical-align: middle;
                  line-height: 38px;
                  font-weight: 500;
                  font-size: 16px;
                  cursor: pointer;
                }
              }
            }
            .upload-wrapper {
              position: relative;
              width: 90px;
              height: 90px;
              background-size: cover;
              background-position: center center;
              background-repeat: no-repeat;
              text-align: left;
              border-radius: 4px;
              cursor: pointer;
              .upload-input {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                cursor: pointer;
              }
            }
            .error-tip {
              position: absolute;
              top: 13px;
              left: 290px;
              line-height: 18px;
              font-size: 13px;
              color: #FF5555;
              white-space: nowrap;
            }
            .upload-tip {
              margin-top: 10px;
              line-height: 17px;
              text-align: left;
              font-size: 13px;
              color: #999999;
            }
          }
        }
        .address-item {
          margin-bottom: 15px;
        }
      }
      .submit-btn {
        width: 340px;
        margin: 20px auto 0;
        line-height: 44px;
        font-size: 16px;
        border-radius: 2px;
      }
      .disabled-btn {
        color: #999;
        background-color: #eee;
      }
      .default-btn {
        color: #fff;
        background-color: $main-color;
        cursor: pointer;
      }
      .protocol-wrapper {
        margin-top: 14px;
        font-size: 0;
        .protocol {
          display: inline-block;
          line-height: 13px;
          font-size: 13px;
          color: $main-color;
          cursor: pointer;
        }
        .tip {
          margin-top: 20px;
          line-height: 18px;
          font-size: 13px;
          color: #999;
          font-weight: 500;
        }
      }
    }
    .apply-result {
      position: relative;
      width: 560px;
      height: 530px;
      text-align: center;
      .result-btn {
        position: absolute;
        left: 50%;
        bottom: 27px;
        width: 340px;
        margin-left: -170px;
        line-height: 44px;
        background-color: $main-color;
        font-size: 16px;
        color: #fff;
        border-radius: 2px;
        cursor: pointer;
      }
      .review-wrapper {
        padding-top: 160px;
        .review-text {
          line-height: 40px;
          font-size: 24px;
          font-weight: 600;
          color: #333;
        }
      }
      .normal-wrapper {
        padding-top: 114px;
        .normal-content {
          line-height: 24px;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          .normal-img {
            width: 80px;
            height: 80px;
            margin-bottom: 30px;
          }
          .tip {
            margin-top: 30px;
            line-height: 20px;
            font-size: 14px;
            color: #999;
            font-weight: 500;
          }
        }
      }
      .applied-wrapper {
        height: 100%;
        &:after {
          content: '';
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }
        .applied-conetnt {
          display: inline-block;
          vertical-align: middle;
          .applied-text {
            line-height: 40px;
            font-size: 24px;
            font-weight: 600;
            color: #000;
          }
          .applied-img-container {
            margin-top: 74px;
            text-align: center;
            .applied-img {
              width: 180px;
              height: 180px;
            }
          }
        }
      }
    }
  }
</style>
